import { render, staticRenderFns } from "./DialogEnviarCorreo.vue?vue&type=template&id=7c2754b7&"
import script from "./DialogEnviarCorreo.vue?vue&type=script&lang=js&"
export * from "./DialogEnviarCorreo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports